var map = {
	"./chathampark/back.jpg": 155,
	"./current/back.jpg": 155,
	"./ranchlife/back-colored.jpg": 346,
	"./ranchlife/back.jpg": 347,
	"./ranchlife/missing.jpg": 348
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 154;